import { EntitySettingsPages } from "@components/settings/constants";
import { getEntityPaneKey } from "@components/settings/lib";
import { useStateAwareNavigate } from "@hooks/useStateAwareNavigate";
import { useScope } from "@state/scopeContext.lib";
import { useCallback } from "react";

export function useGoToClientEntitySettings() {
    const navigate = useStateAwareNavigate();
    const { changeActiveWorkspace } = useScope();

    return useCallback(
        (clientId: string, entityId: number) => {
            changeActiveWorkspace(clientId);
            navigate(
                `/settings/${getEntityPaneKey(EntitySettingsPages.SETTINGS, entityId)}`,
            );
        },
        [changeActiveWorkspace, navigate],
    );
}
